// Types
import type { LoggerFactory } from '@amp/web-apps-logger';
import type { Jet } from '~/jet';
import type { Page } from '../models';
import type { OnListItemClickAction } from '@jet-app/music-classical/action-model/onListItemClickAction';

// Utilities
import { getIntentBuilderFnForType } from '@jet-app/music-classical/utilities/create-flow-action';

// Stores
import { listScreenStore } from '~/stores/list-screen';
import {
    DETAIL_PAGE_TYPE_ALLOWLIST,
    DetailPageType,
} from '@jet-app/music-classical/intents/detail-page/DetailPageIntent';

export type Dependencies = {
    jet: Jet;
    logger: LoggerFactory;
};

export async function registerHandler(dependencies: Dependencies) {
    const { jet, logger } = dependencies;
    const log = logger.loggerFor(
        'jet/action-handlers/on-list-item-click-action',
    );

    jet.onAction(
        'onListItemClickAction',
        async (action: OnListItemClickAction) => {
            log.info('received onListItemClickAction:', action);

            try {
                const intentBuilderFn = getIntentBuilderFnForType(action.type);
                const intent = intentBuilderFn({
                    id: action?.id,
                    ...(DETAIL_PAGE_TYPE_ALLOWLIST.includes(
                        action.type as unknown as DetailPageType,
                    )
                        ? {
                              pageType: action.type,
                          }
                        : {}),
                } as any);
                const page = await jet.dispatch(intent);

                // Setting Store with the fetched detail page
                listScreenStore.setDetailPage(page as Page);
            } catch (error) {
                log.error(
                    'error while performing onListItemClickAction:',
                    error,
                );
            }

            return 'performed';
        },
    );
}
